import { Provider } from "@angular/core";
import { InvoiceApprovalActionHandler } from "./aggregateActionHandlers/invoiceApprovalActionHandler";
import { ApModuleControlService, BankCodeService, CheckStockService, CommodityCodeService, ContractService, FundTotalService, GroupCodeLookupService, InvoiceService, PayableService, PaymentPrintBatchService, PaymentService, PurchaseCardService, SalesTaxCodeLookupService, ShipToLookupService, VendorAddressService, VendorClassLookupService, VendorContactService, VendorDirectDepositService, VendorInvoiceEntryService, VendorLookupService, VendorMergeService, VendorService, VendorSetLookupService, VendorTemplateLookupService } from "./services";

export function provideAccountsPayable(): Array<Provider>
{
    return [
        VendorTemplateLookupService,
        VendorDirectDepositService,
        GroupCodeLookupService,
        ContractService,
        FundTotalService,
        PurchaseCardService,
        VendorMergeService,
        VendorLookupService,
        VendorSetLookupService,
        VendorService,
        VendorContactService,
        VendorClassLookupService,
        ShipToLookupService,
        SalesTaxCodeLookupService,
        PaymentPrintBatchService,
        PaymentService,
        InvoiceService,
        PayableService,
        ApModuleControlService,
        InvoiceApprovalActionHandler,
        VendorInvoiceEntryService,
        VendorAddressService,
        CommodityCodeService,
        CheckStockService,
        BankCodeService,
    ];
}
